import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import AlertConfirm from "../../../components/modals/Confirm";
import Translate from "../../../utils/Translate";
import ReactFlagsSelect from "react-flags-select";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {history} from "../../../utils/history";
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class LeumitCreatePasswordComposed extends Component {
    constructor(props) {
        super(props);

        /*   if (!authenticationService.pwdUserValue) {
               this.props.history.push('/');
           }*/

        this.state = {
            password1: '',
            passwordConfirm: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
            termOfUseSigned: false,
        }
    }

    initValidation = async () => {
        let {t} = this.props

        let validationSchema = Yup.object().shape({
            password1: Yup.string().matches(Config.passwordRegExp, t('defaults.crt_pwd.pwd_validation')).required(t('defaults.crt_pwd.pwd_req')),
            passwordConfirm: Yup.string().oneOf([Yup.ref('password1'), null], t('defaults.crt_pwd.pwd_match')).test('match', t('defaults.crt_pwd.pwd_match'), function (password1) {
                return password1 === this.parent.passwordConfirm
            }).required(t('defaults.crt_pwd.pwd_confirm_req'))
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        let {termOfUseSigned} = this.state
        let {t} = this.props
        let user = authenticationService.pwdUserValue ? authenticationService.pwdUserValue : ""
        let role = user.role ? user.role[0] : ""
        termOfUseSigned = termOfUseSigned || user.profile.TermsOfUseSigned

        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        if (!(termOfUseSigned) && role === "Patient") {
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    proceedLabel: t('defaults.rst_pwd.Ok'),
                    title: t('defaults.crt_pwd.termofuse_title'),
                }
            }, t('defaults.crt_pwd.termofuse_req'))
            return
        }

        if (role !== "Patient") {
            termOfUseSigned = true
        }


        let {password1} = this.state
        let response = await authenticationService.changeNewPassword(password1, termOfUseSigned);
        if (response && response.status < 400) {
            let data = response.data
            if (data && data.hasOwnProperty('newPassword') && data['newPassword'] === true) {
                let path = "/dashboard"
                if (data.role[0] === "Patient") {
                    path = "/pain_patient_self_onboard";
                }

                const {from} = {from: {pathname: appendIchilovQuery(path)}};

                this.props.history.push(from);
            } else {
                await this.setPassword1({target: {value: '', name: 'password1'}})
                await this.setpasswordConfirm({target: {value: '', name: 'passwordConfirm'}})
                this.setState({
                    password1: '',
                    passwordConfirm: '',
                    isErr: true,
                    errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
                })
            }
        } else {
            this.setState({
                password1: '',
                passwordConfirm: '',
                isErr: true,
                errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
            })
        }
    }

    setPassword1 = async (e) => {
        let {auth, validationSchema} = this.state
        let name = 'password1'
        this.setState({password1: e.target.value.trim()})
        utils.set(auth, name, e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false,
            errMessage: ''
        })
    }
    setTermsOfUseSigned = async (e) => {
        this.setState({termOfUseSigned: !this.state.termOfUseSigned})
    }

    setPasswordConfirm = async (e) => {
        let {auth, validationSchema} = this.state
        let name = 'passwordConfirm'
        this.setState({passwordConfirm: e.target.value.trim()})
        utils.set(auth, name, e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false,
            errMessage: ''
        })
    }

    goBack() {
        this.props.history.push(appendIchilovQuery('/login_pain'))

    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {t} = this.props
        let isSigned = true

        let user = authenticationService.pwdUserValue ? authenticationService.pwdUserValue : ""
        let role = user.role ? user.role[0] : ""
        if (role === "Patient")
            isSigned = authenticationService.pwdUserValue ? !!authenticationService.pwdUserValue.profile.TermsOfUseSigned : false;
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-login-main-board'}>
                    <div className={'create-password-label-svg'}>
                        <SvGraphics svgname={'arrow-left'} className={'goBack-icon'} onClick={() => this.goBack()}/>

                        <label className={'sade-login-label-create-Leumit'}>{t('defaults.crt_pwd.new_pwd_info')}</label>
                    </div>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.crt_pwd.pwd')}
                                           type={"password"}
                                           name={"password1"}
                                           value={this.state.password1}
                                           onChange={e => this.setPassword1(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'password1') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'password1')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'password1')}/>
                            </div>

                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.crt_pwd.pwd_valid_lbl')}
                                           type={"password"}
                                           name={"passwordConfirm"}
                                           value={this.state.passwordConfirm}
                                           onChange={e => this.setPasswordConfirm(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'password1') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'passwordConfirm')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'passwordConfirm')}/>

                            </div>

                            <div className="form-group sade-login-form-group">
                                <button className="btn h-centered btn-primary sade-login-form-button"
                                        onClick={this.onSubmit}>{t('defaults.crt_pwd.submit')}</button>
                            </div>

                        </div>
                    </div>
                    <div className={'sade-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.crt_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                </div>

                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
            </div>

        )
    }
}

let PainCreatePassword = compose(
    withTranslation()
)(LeumitCreatePasswordComposed)

export default PainCreatePassword;
